import React from 'react';
import { Platform } from 'react-native';
import { useTheme } from 'react-native-paper';
import { NetInfoStateType, useNetInfo } from '@react-native-community/netinfo';
import { NavigationContainer } from '@react-navigation/native';

import useActiveOnRegions from '@src/hooks/useActiveOnRegions';
import useIsAuthenticated from '@src/hooks/useIsAuthenticated';
// import useLabelsFilled from '@src/hooks/useLabelsFilled';
import useSetupComplete from '@src/hooks/useSetupComplete';

import DummyDashboardStack from './DummyDashboardStack';
import linking from './linking';
import OfflineRootStack from './OfflineRootStack';
import SetupRootStack from './SetupRootStack';
import UnauthenticatedRootStack from './UnauthenticatedRootStack';
import AuthenticatedStack from './WithModalStack';

const Navigation: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();
  const setupComplete = useSetupComplete();
  // const { filled, loading } = useLabelsFilled();
  const region = useActiveOnRegions('IR');

  const theme = useTheme();
  // TODO config net info to work with our servers
  const netInfo = useNetInfo();

  const isOnline = netInfo.isConnected || Platform.OS === 'web';
  const setupCompleted = setupComplete;
  //&& filled;
  const notInRegion = !region;

  if (
    Platform.OS !== 'web' &&
    netInfo.type === NetInfoStateType.unknown
    //|| loading
  ) {
    return null;
  }

  return (
    <NavigationContainer
      linking={linking}
      // @ts-ignore
      theme={theme}
    >
      {isOnline ? (
        isAuthenticated ? (
          notInRegion ? (
            <DummyDashboardStack />
          ) : setupCompleted ? (
            <AuthenticatedStack />
          ) : (
            <SetupRootStack />
          )
        ) : (
          <UnauthenticatedRootStack />
        )
      ) : (
        <OfflineRootStack />
      )}
    </NavigationContainer>
  );
};

export default Navigation;
